module.exports = __webpack_public_path__ + "static/img/wireframe-img-04@t.c14dd70.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/wireframe-img-04@t.png
// module id = 4h1V
// module chunks = 0